import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { API } from '../config';
const o = { withCredentials: true };

// Panel de soporte único: usado tanto en la página "Mi Cuenta" como en el
// menú de perfil de TopBar, para que no existan copias separadas que se
// desincronicen entre sí.
const TicketThread = ({ ticket: t }) => (
  <div className="bg-[#111] rounded p-2 text-xs">
    <p className="text-white font-bold">{t.subject} <span className={t.status === 'respondido' ? 'text-[#00FF88]' : 'text-[#A1A1AA]'}>· {t.status}</span></p>
    {(t.messages || []).map((m, i) => (
      <div key={i} className={`rounded px-2 py-1 mt-1 ${m.from === 'soporte' ? 'bg-white border-l-2 border-[#00FF88] text-gray-800' : 'bg-white border-l-2 border-[#A1A1AA] text-gray-900'}`}>
        <span className="font-bold text-gray-600">{m.from === 'soporte' ? `Soporte${m.agent ? ' (' + m.agent + ')' : ''}: ` : 'Tú: '}</span>{m.text}
        {m.at && <span className="text-gray-400 ml-2 text-[10px]">{new Date(m.at).toLocaleString()}</span>}
      </div>
    ))}
  </div>
);

const SupportPanel = ({ compact = false }) => {
  const [tickets, setTickets] = useState([]);
  const [asunto, setAsunto] = useState('');
  const [msg, setMsg] = useState('');

  const cargar = async () => {
    try { setTickets((await axios.get(`${API}/support/my-tickets`, o)).data.tickets || []); } catch {}
  };

  useEffect(() => { cargar(); }, []);

  const enviar = async () => {
    if (!asunto.trim() || !msg.trim()) return;
    await axios.post(`${API}/support/message?subject=${encodeURIComponent(asunto)}&message=${encodeURIComponent(msg)}`, {}, o);
    setAsunto(''); setMsg(''); cargar();
  };

  const abiertos = tickets.filter(t => t.status !== 'cerrado');
  const cerrados = tickets.filter(t => t.status === 'cerrado');

  return (
    <div className="space-y-2">
      <div className={compact ? 'space-y-1' : 'flex gap-2'}>
        <input value={asunto} onChange={(e) => setAsunto(e.target.value)} placeholder="Asunto"
          className={`bg-[#111] border border-[#27272A] rounded px-2 py-1.5 text-white text-sm ${compact ? 'w-full' : 'w-48'}`} />
        {compact ? (
          <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={2} placeholder="Describe tu problema"
            className="w-full bg-[#111] border border-[#27272A] rounded px-2 py-1.5 text-white text-sm" />
        ) : (
          <input value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Describe tu problema"
            className="bg-[#111] border border-[#27272A] rounded px-2 py-1.5 text-white text-sm flex-1" />
        )}
        <button onClick={enviar}
          className={`rounded bg-[#00D4FF] text-black text-xs font-bold ${compact ? 'w-full py-1.5' : 'px-3 py-1.5 shrink-0'}`}>
          Enviar
        </button>
      </div>
      {abiertos.map((t) => <TicketThread key={t.ticket_id} ticket={t} />)}
      {!abiertos.length && !cerrados.length && <p className="text-[#A1A1AA] text-xs">Sin tickets todavía</p>}
      {cerrados.length > 0 && (
        <details className="text-[#52525B]">
          <summary className="text-xs cursor-pointer hover:text-white">Ver resueltos ({cerrados.length})</summary>
          <div className="mt-2 space-y-2">
            {cerrados.map((t) => <TicketThread key={t.ticket_id} ticket={t} />)}
          </div>
        </details>
      )}
    </div>
  );
};

export default SupportPanel;
